import React, { useEffect, useState } from "react";
import AlertInfo from "../../assets/images/alertInfo.svg";
import CheckboxOn from "../../assets/images/CheckboxOn.svg";
import CheckboxOff from "../../assets/images/CheckboxOff.svg";

export default function PriceCompareTests(props) {
  let { val, radiovalue, mobileView, handleSelectAll, recommendedpartneruuid } =
    props;

  const [value, setValue] = useState("product");

  const [checked, setChecked] = useState(true);

  let selectProduct = (e, uuid, val) => {
    setChecked(e.target.checked);
    props.handleRadio(uuid, val);
    if (e.target.checked === false) {
      handleSelectAll(false);
    }
  };

  useEffect(() => {
    if (radiovalue && JSON.stringify(radiovalue).includes(val.uuid)) {
      setChecked(true);
    } else {
      setChecked(false);
    }
  }, [radiovalue]);

  return (
    <>
      {mobileView ? (
        <div className="wrapper">
          <div className="mid-cont">
            <div className="header-text">{val.standardisedtestname} </div>
            <div className="header-text">
              {" "}
              {props.recommendedTest &&
                props.recommendedTest.test_uuid.includes(val.testname_uuid)
                ? `(${"Recommended Test"})`
                : ""}
            </div>
            <div className="sub-header-text">
              Results Expected in : {val.standardiseddoctalltat}
            </div>
            {val.homeserviceavailability == "AVAILABLE" ? (
              ""
            ) : (
              <div className="info-text">
                <img src={AlertInfo} alt="AlertInfo" />
                <div className="info-font">
                  Home sample collection not available
                </div>
              </div>
            )}
          </div>
          <div className="end-cont">
            <div className="header-price">
              ₦{Number(val.doctallsexclusivediscountedprice).toFixed()}
            </div>
            <div className="sub-header-price-cont">
              <div className="head-font">
                {val.discountofferedforretail * 100 === 0 ? ""
                  :
                  <div>
                    ₦{Number(val.labretailprice).toFixed()}
                  </div>
                }
              </div>
              <div className="sub-font-cont">
                <span>
                  {val.discountofferedforretail * 100 === 0 ? "" : "-"}
                  {/* {val.discountofferedforretail &&
                    val.discountofferedforretail &&} */}
                  {val.discountofferedforretail &&
                    val.discountofferedforretail * 100 === 0 ? "" : val.discountofferedforretail * 100}
                  {val.discountofferedforretail * 100 === 0 ? "" : "% "}
                </span>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <>
          <div className="mid-cont">
            <div className="header-text">{val.standardisedtestname}</div>
            <div className="header-text">
              {" "}
              {props.recommendedTest &&
                props.recommendedTest.test_uuid.includes(val.testname_uuid)
                ? `(${"Recommended Test"})`
                : ""}
            </div>
            <div className="sub-header-text">
              Results Expected in : {val.standardiseddoctalltat}
            </div>
            {val.homeserviceavailability == "AVAILABLE" ? (
              ""
            ) : (
              <div className="info-text">
                <img src={AlertInfo} alt="AlertInfo" />
                <div className="info-font">
                  Home sample collection not available
                </div>
              </div>
            )}
          </div>
          <div className="end-cont">
            <div className="header-price">
              {/* {console.log(Number(val.doctallsexclusivediscountedprice).toFixed(2))} */}
              ₦{Number(val.doctallsexclusivediscountedprice).toFixed()}
              {/* ₦{Number(val.doctallsexclusivediscountedprice)} */}
            </div>
            <div className="sub-header-price-cont">
              <div className="head-font">
                {val.discountofferedforretail * 100 === 0 ? ""
                  :
                  <div>
                    ₦{Number(val.labretailprice).toFixed()}
                  </div>
                }
                {/* ₦{Number(val.labretailprice).toFixed()} */}
                {/* ₦{Number(val.labretailprice)} */}
              </div>
              <div className="sub-font-cont">
                <span>
                  {/* {val.discountofferedforretail &&
                    val.discountofferedforretail * 100} */}
                  {val.discountofferedforretail * 100 === 0 ? "" : "-"}
                  {val.discountofferedforretail &&
                    val.discountofferedforretail * 100 === 0 ? "" : val.discountofferedforretail * 100}
                  {val.discountofferedforretail * 100 === 0 ? "" : "% "}
                </span>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}
